module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "flipCard",
    staticClass: "relative span-14-md offset-1-md span-14-sm offset-1-sm span-14-xs offset-1-xs share-flip-outer no-border content-translate",
    class: [_vm.cardSizeClass, _vm.contentActiveClass],
    style: (_vm.ratio_styles)
  }, [_c('div', {
    staticClass: "flip-container"
  }, [_c('div', {
    staticClass: "flipper crosshair-rollover-trigger",
    on: {
      "click": _vm.flip
    }
  }, [_c('div', {
    staticClass: "front ind-2 border-blue-hover center-flex",
    class: _vm.flipped,
    attrs: {
      "front-card": ""
    }
  }, [_c('div', {
    staticClass: "front-inner"
  }, [(_vm.icon) ? _c('div', {
    staticClass: "svg-icon-background big-svg"
  }, [_c(_vm.icon, {
    tag: "component"
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "subheader "
  }, [_vm._v(_vm._s(_vm.title))])])]), _vm._v(" "), _c('div', {
    staticClass: "back border-blue-hover",
    class: _vm.flipped
  }, [_c('div', {
    ref: "scrollHookOne",
    staticClass: "scroll-outer maintain-outer"
  }, [_c('div', {
    staticClass: "back-inner"
  }, [_c('div', {
    staticClass: "subheader "
  }, [(_vm.icon) ? _c('div', {
    staticClass: "svg-icon-background svg-icon-background-small"
  }, [_c(_vm.icon, {
    tag: "component"
  })], 1) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('p', [_vm._t("default")], 2)])])])]), _vm._v(" "), (_vm.cardSize < 4) ? _c('crosshair-background') : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-66536010"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/molecules/flip_card.vue
// module id = 633
// module chunks = 1